export const apiCreate = (): string => '/commercial/statusProposals/create'
export const apiList = (id?: string): string =>
  !id
    ? '/commercial/statusProposals/'
    : `/commercial/statusProposals/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/statusProposals/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/statusProposals/delete/${id}`
